import React, { ReactNode } from "react";
import { Button, Text, Flex, Box } from "@radix-ui/themes";
import { copyToClipboard } from "@/shared/helpers/copy-to-clipboard";

interface InfoItemProps {
  label: string;
  value?: string | number | null;
  copyValue?: string | number;
  multiRow?: boolean;
  children?: ReactNode;
}

export const InfoItem: React.FC<InfoItemProps> = ({
  label,
  value,
  copyValue,
  multiRow = false,
  children,
}) => {
  const handleCopy = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    const textToCopy = copyValue?.toString() || value?.toString();
    if (textToCopy) {
      copyToClipboard(textToCopy);
    }
  };

  const displayValue = (val?: string | number | null) => {
    if (val === undefined) {
      return null;
    }
    if (val === 0 || val === "0" || (val && val !== "")) {
      return val;
    }
    return "-";
  };

  if (multiRow) {
    return (
      <Flex className="pt-1" direction="column">
        <Flex>
          <Text size="1" color="gray" className="min-w-fit">
            {label}:
          </Text>
        </Flex>
        <Box>
          <Button
            variant="ghost"
            color="gray"
            className="mx-1 my-0.5"
            onClick={handleCopy}
          >
            <Text size="1" color="gray" highContrast>
              {displayValue(value)}
            </Text>
          </Button>
        </Box>

        {children}
      </Flex>
    );
  }

  return (
    <Flex className="py-1">
      <Text size="1" color="gray" className="min-w-fit">
        {label}:
      </Text>
      <Button
        variant="ghost"
        color="gray"
        className="px-1 ml-0 mr-1"
        onClick={handleCopy}
      >
        <Text size="1" color="gray" highContrast>
          {displayValue(value)}
        </Text>
      </Button>
      {children}
    </Flex>
  );
};
